import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import BoardFree from '../components/boards/BoardFree';
import BoardUml from '../components/boards/BoardUml';
import BoardC4 from '../components/boards/BoardC4';
import BoardArchimate from '../components/boards/BoardArchimate';
import BoardBpmn from '../components/boards/BoardBpmn';
import BoardBcm from '../components/boards/BoardBcm';
import BoardErd from '../components/boards/BoardErd';
import { getDiagramById } from '../api/diagramsApi';
import { useProject } from '../context/ProjectContext';

const BOARD_TYPES = ['uml', 'c4', 'free', 'archimate', 'bpmn', 'bcm', 'erd'];

const EditorPage = () => {
  const { diagramId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const urlType = params.get('type');
  const urlProject = params.get('project') || null;
  const metamodelId = params.get('metamodelId') ?? null;
  const { currentProject } = useProject();
  // Prefer explicit ?project= URL param; fall back to the currently selected project in context.
  const project = urlProject || currentProject?.id || null;

  // When a diagram is opened by ID without ?type=, detect the type from its metadata
  const [detectedType, setDetectedType] = useState(null);
  useEffect(() => {
    if (!diagramId || urlType) return;
    setDetectedType(null);
    getDiagramById(project, diagramId)
      .then((diagram) => {
        const type = diagram.meta?.type || 'uml';
        const validType = BOARD_TYPES.includes(type) ? type : 'uml';
        // Update the URL so refreshing preserves the type
        const qs = new URLSearchParams({ type: validType, ...(project ? { project } : {}) });
        navigate(`/editor/${diagramId}?${qs}`, { replace: true });
      })
      .catch(() => setDetectedType('uml'));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [diagramId, urlType]);

  const mode = urlType || detectedType || 'uml';

  // Show nothing while we're detecting the type (avoid briefly mounting the wrong board)
  if (diagramId && !urlType && !detectedType) return null;

  if (mode === 'free') return <BoardFree diagramId={diagramId || null} projectId={project} initialMetamodelId={metamodelId} />;
  if (mode === 'c4') return <BoardC4 diagramId={diagramId || null} projectId={project} />;
  if (mode === 'archimate') return <BoardArchimate diagramId={diagramId || null} projectId={project} />;
  if (mode === 'bpmn') return <BoardBpmn diagramId={diagramId || null} projectId={project} />;
  if (mode === 'bcm') return <BoardBcm diagramId={diagramId || null} projectId={project} />;
  if (mode === 'erd') return <BoardErd diagramId={diagramId || null} projectId={project} />;
  return <BoardUml diagramId={diagramId || null} projectId={project} />;
};

export default EditorPage;
